/**
 * BUXTRADE BEETROOT POWDER — LANDING PAGE SCRIPTS
 * Asset: beetroot-landing.js
 *
 * Initialised via DOMContentLoaded so it is safe to load
 * with defer or at end-of-body. Multiple section instances
 * on the same page will not re-initialise already-observed
 * elements thanks to the WeakSet guard.
 */

(function () {
  'use strict';

  // Guard against double-init when Shopify re-renders sections in the editor
  if (window.__buxtradeLPInit) return;
  window.__buxtradeLPInit = true;

  /* ----------------------------------------------------------
     FAQ ACCORDION
     ---------------------------------------------------------- */
  function initFaq() {
    document.querySelectorAll('.faq-item__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var answer = btn.nextElementSibling;
        var isOpen = btn.classList.contains('open');

        // Close all open items
        document.querySelectorAll('.faq-item__q.open').forEach(function (b) {
          b.classList.remove('open');
          b.nextElementSibling.classList.remove('open');
        });

        // If it was closed, open it
        if (!isOpen) {
          btn.classList.add('open');
          answer.classList.add('open');
        }
      });
    });
  }

  /* ----------------------------------------------------------
     SCROLL ANIMATIONS (IntersectionObserver)
     ---------------------------------------------------------- */
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: make all elements visible immediately
      document.querySelectorAll('.fade-up').forEach(function (el) {
        el.classList.add('visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('.fade-up').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ----------------------------------------------------------
     SMOOTH ANCHOR SCROLL
     Scoped to #-links only; does not interfere with Shopify
     theme nav links.
     ---------------------------------------------------------- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var href = anchor.getAttribute('href');
        if (href === '#') return;
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ----------------------------------------------------------
     MOBILE NAV HAMBURGER
     Only activates if a .nav element exists on the page.
     Designed to coexist with Shopify theme navs — targets
     the landing-page nav by ID only.
     ---------------------------------------------------------- */
  function initMobileNav() {
    var hamburger = document.getElementById('beet-hamburger');
    var navLinks  = document.getElementById('beet-nav-links');
    if (!hamburger || !navLinks) return;

    hamburger.addEventListener('click', function () {
      var isOpen = navLinks.dataset.open === 'true';
      if (isOpen) {
        navLinks.style.cssText = '';
        navLinks.dataset.open = 'false';
      } else {
        navLinks.style.cssText = [
          'display:flex',
          'flex-direction:column',
          'position:absolute',
          'top:100%',
          'left:0',
          'right:0',
          'background:rgba(248,246,243,.97)',
          'backdrop-filter:blur(20px)',
          '-webkit-backdrop-filter:blur(20px)',
          'padding:20px 24px',
          'gap:16px',
          'box-shadow:0 8px 32px rgba(30,30,30,.1)',
          'z-index:99',
        ].join(';');
        navLinks.dataset.open = 'true';
      }
    });
  }

  /* ----------------------------------------------------------
     SHOPIFY SECTION EVENTS
     Re-initialise scripts when the theme editor adds/removes
     or re-renders a section without a full page reload.
     ---------------------------------------------------------- */
  document.addEventListener('shopify:section:load', function (e) {
    // Reset the init guard for the reloaded section only
    window.__buxtradeLPInit = false;
    initFaq();
    initScrollAnimations();
    initSmoothScroll();
    initMobileNav();
    window.__buxtradeLPInit = true;
  });

  /* ----------------------------------------------------------
     BOOT
     ---------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  function boot() {
    initFaq();
    initScrollAnimations();
    initSmoothScroll();
    initMobileNav();
  }
})();
